import React from 'react';
import { cn } from '@/helpers/utils';
import { useRouteParams } from '@/context/routeParamsContext';
import { useLoungeAmenitiesWithLocaleTranslations } from '@/hooks/loungesHooks/loungesHelperHooks';
import { useCommonContent } from '@/hooks/oneCmsIntlHooks/oneCmsIntlHelperHooks';

import {
  IconBeerAndWine,
  IconCardholder18,
  IconCardholder21,
  IconChildrensArea,
  IconClothesPress,
  IconComputers,
  IconConfRooms,
  IconFlightMonitors,
  IconGym,
  IconLounge,
  IconNewspapersAndMagazines,
  IconNoSmoking,
  IconPremiumDrinks,
  IconPremiumFood,
  IconPrintersAndCopiers,
  IconPrivateRooms,
  IconShoeShine,
  IconShowers,
  IconSmokingAreas,
  IconSnacks,
  IconSpaServices,
  IconTablets,
  IconTelephones,
  IconTV,
  IconWiFi,
} from '../icons';

const LoungeDetailsAmenitiesList = () => {
  const { loungeId } = useRouteParams();
  const amenities = useLoungeAmenitiesWithLocaleTranslations(loungeId);
  const content = useCommonContent();
  const amenityIdToIconMap = {
    '18_CARDHOLDER': IconCardholder18,
    '21_CARDHOLDER': IconCardholder21,
    'NON-SMOKING': IconNoSmoking,
    BEER_WINE_FREE: IconBeerAndWine,
    BEER_WINE: IconBeerAndWine,
    CHILDREN_ROOMS: IconChildrensArea,
    CONFERENCE_ROOMS_FREE: IconConfRooms,
    CONFERENCE_ROOMS: IconConfRooms,
    FLIGHT_MONITORS: IconFlightMonitors,
    INTERNET_TERMINALS: IconComputers,
    NEWSPAPERS: IconNewspapersAndMagazines,
    PREMIUM_FOOD_FREE: IconPremiumFood,
    PREMIUM_FOOD: IconPremiumFood,
    PRINTERS_FREE: IconPrintersAndCopiers,
    PRINTERS: IconPrintersAndCopiers,
    PRIVATE_ROOMS_FREE: IconPrivateRooms,
    PRIVATE_ROOMS: IconPrivateRooms,
    SHOWERS_FREE: IconShowers,
    SHOWERS: IconShowers,
    SNACKS_FREE: IconSnacks,
    SPA_FREE: IconSpaServices,
    SPA: IconSpaServices,
    SPIRITS_LIQUOR_FREE: IconPremiumDrinks,
    SPIRITS_LIQUOR: IconPremiumDrinks,
    TELEPHONES: IconTelephones,
    TV: IconTV,
    WIFI_FREE: IconWiFi,
    WIFI: IconWiFi,
    LOUNGEBUDDY_CHECKIN: IconTablets,
    CLOTHES_PRESS_FREE: IconClothesPress,
    GYM_FREE: IconGym,
    GYM: IconGym,
    SHOE_SHINE: IconShoeShine,
    SMOKING_ROOMS: IconSmokingAreas,
  };

  return (
    <div className="margin-0-b">
      <h2 className="margin-1-b tw-heading-xs-bold tw-text-gray-900">
        {content?.amenities?.header}
      </h2>
      <div
        id="lounge-overview-amenity-list"
        className={cn(
          'pad-0-lr tw-mt-4 tw-grid tw-grid-cols-1 sm_tw-grid-cols-2'
        )}
      >
        {amenities.map((amenity) => {
          const TheIcon = amenityIdToIconMap[amenity.id] || IconLounge;

          return (
            <div
              key={amenity.id}
              className={cn(
                'leading-4 ps-0 pe-0 flex tw-mb-4 tw-mr-6 svg-children_tw-fill-gray-800',
                amenity.id
              )}
            >
              <div>
                <TheIcon className="tw-mr-2" color="inherit" size="md" />
              </div>
              {amenity.label}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default LoungeDetailsAmenitiesList;
